/** @format */

import colors from "@src/style/colors";

export const commonInfo = {
  btn: {
    image: "/img/icons/feature/menu.png"
  },
  logo: {
    sandbank: {
      image: "/img/icons/logo/sandbank_logo.svg"
    },
    surf: {
      image: "/img/pages/main/logo-surf.png"
    }
  },
  navbar: [
    {
      name: "SURF",
      url: "https://surf.sandbank.io"
    },
    {
      name: "COMPANY",
      url: "https://corp.sandbank.io/"
    },
    {
      name: "RECRUIT",
      url: "https://sandbank.oopy.io/?utm_source=Homepage&utm_medium=link&utm_campaign=recruit"
    }
  ],

  intro: {
    img: {
      phone_image: "/img/pages/main/intro_phone.png"
    },
    video: {
      intro: "/videos/intro_sandbank.mp4"
    }
  },
  partner: {
    title: "믿을 수 있는 파트너들과 함께합니다",
    items: [
      {
        name: "PRIMER",
        image: "/img/pages/main/partner_primer.png",
        url: "https://primer.kr"
      },
      {
        name: "STRONG VENTURES",
        image: "/img/pages/main/partner_strongVentures.png",
        url: "https://www.strongvc.com"
      },
      {
        name: "KICA",
        image: "/img/pages/main/partner_kica.png",
        url: "https://www.kica.co.kr/kica/main/formMain.sg"
      },
      {
        name: "GOOGLE FOR STARTUP",
        image: "/img/pages/main/partner_google.png",
        url: "https://www.campus.co/intl/ko_kr/seoul/"
      },
      {
        name: "CHAINLINK",
        image: "/img/pages/main/partner_chainlink.png",
        url: "https://chain.link"
      },
      {
        name: "HAECHI LABS",
        image: "/img/pages/main/partner_haechi.png",
        url: "https://haechi.io"
      },
      {
        name: "HEXLANT",
        image: "/img/pages/main/partner_hexlant.png",
        url: "https://hexlant.com"
      }
    ]
  },
  strength: {
    title: {
      sm: "샌드뱅크는 이런 서비스입니다",
      else: "샌드뱅크는 이런 서비스입니다"
    },
    description:
      "간편한 크립토 자산 관리부터 다채로운 투자 상품, 업계 전문가들의 인사이트까지! <br /> 이제 새로운 WEB 3.0 금융을 경험하세요. 투자가 더욱 즐겁고 편리해집니다.",
    items: [
      {
        text: "안정적 수익",
        top: "",
        bottom: "",
        left: "",
        right: ""
      },
      {
        text: "자산 관리",
        top: "",
        bottom: "",
        left: "",
        right: ""
      },
      {
        text: "투자 인사이트",
        top: "",
        bottom: "",
        left: "",
        right: ""
      },
      {
        text: "철저한 보안",
        top: "",
        bottom: "",
        left: "",
        right: ""
      }
    ],
    img: {
      phone_image: "/img/pages/main/iPhone-homepage-strength.png"
    }
  },
  feature: [
    {
      id: 1,
      title: "스마트한 자산관리",
      description:
        "이제 크립토 투자가 훨씬 편리해져요.<br/>샌드뱅크에 거래소와 개인지갑을 연동한 투자자는 흩어진 자산을 한 곳에서 통합 관리할 수 있어요. 나의 전체 자산과 모든 거래 내역을 간편하게 확인해보세요.",
      image: "/img/pages/main/feature_1.png"
    },
    // {
    //   id: 2,
    //   title: "다채로운 크립토 투자",
    //   description:
    //     "크립토 시장의 여러 전략을 활용하여 투자를 경험해볼 수 있어요",
    //   image: "/img/pages/main/feature_2.png"
    // },
    {
      id: 3,
      title: "인사이트 가득한<br/>프리미엄 콘텐츠",
      description:
        "엄선된 콘텐츠로 투자에 도움되는 정확한 인사이트를 제공하여 드려요. 좋아하는 크리에이터를 구독하고 알림 받아보세요.",
      image: "/img/pages/main/feature_3.png"
    }
    // {
    //   id: 4,
    //   title: "멀티시그 지갑으로<br/> 철저한 보안",
    //   description:
    //     "출금 승인에 필요한 개인 키가 여러개로 나뉘어 샌드뱅크와 수탁사에 각각 보관돼요. 해킹과 보안 사고로부터 자산을 안전하게 보호할 수 있어요.",
    //   image: "/img/pages/main/feature_4.png"
    // }
  ],
  value: {
    title: "왜 샌드뱅크인가요?",
    title_else: "왜 샌드뱅크인가요?",
    items: [
      {
        title: "한 눈에 파악할 수 있는<br/>나의 크립토 투자 현황",
        description:
          "“XX 거래소에 크립토가 몇개 있었지?”<br/>“내가 그저께 매수 매도를 얼마에 했더라?”<br/>샌드뱅크와 함께라면 이런 고민 없이 투자를 즐길 수 있어요.",
        img: "/img/pages/main/Value_1.jpg"
      },
      // {
      //   title: "잠자는 크립토를 일하게 하는<br/>다양한 투자 상품",
      //   description:
      //     "손실을 입은 트레이딩 경험이 있으신가요?<br/>크립토를 그냥 두기에는 아쉽게 느껴지나요?<br/>전문적인 자산운용을 통해 안정적인 수익을 돌려드려요. ",
      //   img: "/img/pages/main/Value_2.jpg"
      // },
      {
        title: "전문가들이 엄선한<br/>크립토 콘텐츠",
        description:
          "투자 정보를 찾아서 여러 텔레그램 채널들을 둘러보고 계신가요?<br/>이제 샌드뱅크 하나만 있으면 허위정보나 광고없이 편리하게 인사이트를 얻으실 수 있어요.",
        img: "/img/pages/main/Value_3.jpg"
      }
      // {
      //   title: "보안사고 0회<br/>미지급 수익 0원",
      //   description:
      //     "샌드뱅크는 설립 이래 한번도<br/>고객 자산이 탈취되거나 수익이 미지급된 적이 없습니다.<br/>안심하고 이용하세요.",
      //   img: "/img/pages/main/Value_4.jpg"
      // }
    ]
  },
  message: {
    title: "돈의 가치가 떨어지는 시대",
    subtitle: "크립토 투자는<br/>선택이 아니라 필수.",
    subtitle_else: "크립토 투자는 선택이 아니라 필수.",
    description:
      "샌드뱅크는 기존에 없던 서비스로<br/>여러분의 성공적인 크립토 투자를 돕습니다.",
    text: "우리 일상생활의 많은 부분이<br/>디지털로 전환되는 시대.<br/>크립토는 인터넷 위에 구축된<br/>새로운 가치저장 수단입니다.<br/>차근차근 자산을 모으는 즐거움을 느껴보세요.",
    text_else:
      "우리 일상생활의 많은 부분이 디지털로 전환되는 시대.<br/>크립토는 인터넷 위에 구축된 새로운 가치저장 수단입니다.<br/>차근차근 자산을 모으는 즐거움을 느껴보세요."
  },

  growth: {
    title: "신뢰를 바탕으로<br/>성장합니다",
    title_else: "신뢰를 바탕으로 성장합니다"
  },

  review: {
    title: "유저 리뷰",
    items: [
      '"크립토 자산이 어떻게 불어나는지 데일리로 볼 수 있어서 좋았습니다 😊"',
      '"쓰기 편하고 수익률 확인 하는게 간편해서 좋아요 👍"',
      '"앱 사용하기 너무 편하고요 덤으로 이자도 받을 수 있어 너무 잘 사용하고 있습니다!"',
      '"장기적으로 가져가려고 크립토 모으고 있는데 넣어놓으면 이자까지 받을 수 있어서 너무 좋네요! 앱 사용하기도 엄청 편합니다."',
      '"사용하기 편하고 수익이 많이 나서 좋아요. 크립토에 대해 잘 모르지만 저도 사용하기 쉽고 편한거 같아 만족해요! 추천합니다."',
      '"안전한 수량 늘리기 샌드뱅크 💰"',
      '"장기투자 하시는 분 권장합니다."',
      '"신뢰가 가요!"'
    ]
  },
  security: {
    title: "샌드뱅크는 안전한가요?",
    items: [
      {
        id: 1,
        bgColor: colors.coolGray,
        textColor: colors.white,
        iconColor: colors.white,
        image: "/img/pages/main/main_secure_1.png",
        title: "ISO/IEC 27001<br/>인증 서비스",
        title_else: "ISO/IEC 27001<br/>인증 서비스",

        back_title: "ISO/IEC 27001 인증 서비스",
        text: "ISO/IEC 27001 인증은 국제표준화기구(ISO)에서 제정한 정보보호 관리체계(ISMS, Information Security Management System)의 요구사항을 규정하며, 정보보호분야에서 가장 권위있는 국제 표준 인증입니다. 샌드뱅크는 법률을 준수하고 고객의 소중한 정보 자산을 안전하게 관리하는, 신뢰할 수 있는 서비스입니다.",
        list: ["회사명 - (주)디에이그라운드", "인증번호 - ACT-IC-2157"],
        icon_front: "/img/icons/feature/icon_filp-light.png",
        icon_back: "/img/icons/feature/icon_filpback-light.png"
      },
      {
        id: 2,
        bgColor: colors.blue,
        textColor: colors.white,
        iconColor: colors.white,
        image: "/img/pages/main/main_secure_2.png",
        title: "전문 수탁사의<br/>멀티시그 지갑",
        title_else: "전문 수탁사의<br/>멀티시그 지갑",

        back_title: "전문 수탁사의<br/>멀티시그 지갑",
        text: "고객 자산을 보관중인 지갑의 분산된 3개의 키 중 2개 이상을 획득해야만 출금할 수 있는 멀티시그(Multisig) 방식으로 관리합니다. 해커로부터의 침입이나 실수로 인한 자산출금은 허용되지 않습니다.<br/>모든 비정상적인 접속과 입출금 시도로부터 자산을 안전하게 보호하고 불법 자금을 이용한 범죄행위를 막기 위한는 FDS 시스템이 적용되어 있으며, AML 솔루션을 통해 Blacklist 지갑주소와의 입출금은 자동적으로 차단함으로써 불법 자금세탁을 사전 방지할 수 있도록 관리합니다.",
        icon_front: "/img/icons/feature/icon_filp-light.png",
        icon_back: "/img/icons/feature/icon_filpback-light.png"
      },
      // {
      //   id: 3,
      //   bgColor: colors.white,
      //   textColor: colors.black,
      //   iconColor: colors.coolGray200,
      //   image: "/img/pages/main/main_secure_3.png",
      //   title: "투명한 가상자산<br/>실사결과 공개",
      //   title_else: "투명한 가상자산<br/>실사결과 공개",

      //   back_title: "투명한 가상자산<br/>실사결과 공개",
      //   text: "샌드뱅크는 외부 회계법인을 통해 매 분기 종료 후 가상자산 보관 수량에 대한 실사를 진행하며, 해당 실사 보고서를 공개하고 있습니다.<br/><br/>-2022년 3분기 실사 보고서<br/>-2022년 4분기 실사 보고서 <br/><br/>샌드뱅크는 항상 자산의 안전성을 투명하게 공개함으로써 신뢰도 높은 서비스를 제공하고자 합니다.",
      //   icon_front: "/img/icons/feature/icon_filp-dark.png",
      //   icon_back: "/img/icons/feature/icon_filpback-dark.png"
      // },
      {
        id: 4,
        bgColor: colors.coolGray500,
        textColor: colors.black,
        iconColor: colors.white,
        image: "/img/pages/main/main_secure_4.png",
        title: "개인정보<br/>배상책임보험 가입",
        title_else: "개인정보<br/>배상책임보험 가입",

        back_title: "개인정보 배상책임보험",
        text: "샌드뱅크는 개인정보의 예상치 못한 유출로 인해 고객의 피해가 발생할 경우를 대비하여 법률상의 손해배상책임을 보상하고, 이에 따른 위기의 부정적 영향을 최소화하도록 현대해상화재보험(주)의 개인정보 배상책임보험에 가입되어있습니다.<br/>예상치 못한 개인정보 유출로 이용자 피해가 발생할 경우를 대비해 기업이 보험에 가입하거나 준비금을 적립하도록 한 제도이며, 각종 사이버 위험으로 회사가 이용자에 대해 법률 상의 손해배상 책임을 지게 돼 입는 재정적 손해를 보상하는 보험입니다.",
        icon_front: "/img/icons/feature/icon_filp-light.png",
        icon_back: "/img/icons/feature/icon_filpback-light.png"
      }
    ]
  },

  qna: {
    title: "자주 묻는 질문",
    items: [
      {
        title: "샌드뱅크는 어떤 서비스인가요?",
        description:
          "샌드뱅크는 크립토 자산관리 및 투자 서비스로, 자체 오픈 뱅킹 기술을 활용한 최적의 자산관리, 포트폴리오 분석 및 추천 기능을 제공합니다. 2023년에는 사용자 경험을 혁신적으로 개선한 샌드뱅크 2.0을 출시하여, 고객의 자산 배분을 최적화하고 수익률을 높이면서도 리스크를 관리할 수 있는 서비스를 제공하고 있습니다."
      },
      {
        title: "WEB 3.0 금융은 무엇이고 샌드뱅크와 어떤 연관이 있나요?",
        description:
          "WEB 3.0 금융은 블록체인 기술을 이용하여 투명하고, 모두에게 개방된 서비스를 제공하는 새로운 금융 패러다임입니다. 이는 기존의 중앙 집중식 금융 시스템, 즉 금융 기관이 자산을 대신 관리해주는 방식에서 벗어나, 사용자 스스로가 자신의 자산을 직접 관리하며 빠르고 효율적인 거래를 원활하게 진행할 수 있도록 하는 것을 목표로 합니다. <br/><br/>샌드뱅크는 바로 이 WEB 3.0 금융의 혁신을 주도하고 있습니다. 여러 크립토 자산 지갑을 한 곳에서 편리하게 관리할 수 있도록 돕고 있으며, 이를 통해 모든 이가 참여할 수 있는 미래의 금융 시스템 구축에 앞장서고 있습니다."
      },
      {
        title: "크립토 자산관리는 어떤 기능인가요?",
        description:
          "샌드뱅크에서는 누구나 거래소 및 개인 지갑에 분산되어 있는 크립토 자산 포트폴리오를 쉽고 빠르게 연동할 수 있습니다. 이를 통해 자산 흐름을 추적하고 분석하여 최적의 자산 배분을 제안합니다. 현재 한국 거래소 4개(업비트, 빗썸, 코인원, 코빗), 세계 최대 거래소 바이낸스, 메타마스크와 같은 개인지갑도 모두 연동이 가능하며, OAuth 방식(최초 1회 거래소 계정 로그인)을 사용하여 매우 쉽고 빠르게 연동할 수 있습니다. 현재 국내에서 가장 많은 OAuth 방식 연동처를 제공합니다."
      },
      // {
      //   title: "어떤 종류의 투자 상품을 제공하나요?",
      //   description:
      //     "샌드뱅크에서는 퀀트 트레이딩 전략 기반의 고정 수익형 상품(BTC, ETH, USDT, XRP)을 통해 연간 최대 10% 이상의 수익을 얻을 수 있습니다. 더불어, 인덱스 기반의 패시브 상품, PoS 온체인 상품 등 다양한 투자 선택지를 준비하고 있습니다. 이를 통해 사용자들은 자신의 투자 성향과 필요에 따라 맞춤형 투자 포트폴리오를 구성할 수 있습니다."
      // },
      {
        title: "회원가입은 어디서 할 수 있나요?",
        description:
          "샌드뱅크 모바일 앱을 통해서 가능합니다. 구글 플레이 스토어 혹은 애플 앱 스토어에서 앱을 다운로드하신 후 회원가입 절차를 진행하실 수 있습니다."
      },
      // {
      //   title: "샌드뱅크 계정에 입금은 어떻게 하나요?",
      //   description:
      //     "거래소 또는 개인 지갑에 있는 크립토 자산을 샌드뱅크 계정에 생성한 지갑 주소로 전송하는 방식으로 입금할 수 있습니다. 국내 거래소(업비트, 빗썸, 코빗, 코인원, 고팍스)에서는 100만원 미만의 금액만 즉시 입금이 가능하며, 100만원 이상의 금액은 해외 거래소 또는 개인 지갑을 한번 거치는 과정이 필요합니다. 이때는 전송 수수료가 상대적으로 저렴한 리플(XRP)이나 트론(TRX)을 바이낸스 등 해외 거래소로 전송한 다음, 원하는 자산으로 교환하여 입금하는 방식으로 입금 과정에서 발생하는 비용을 최소화할 수 있습니다. 입금 과정에서 도움이 필요하신 경우, 고객센터를 통해 문의 주시면 친절하게 도와 드리겠습니다."
      // },
      {
        title: "모바일 앱과 홈페이지 서비스 모두 제공되나요?",
        description: "현재는 모바일 앱 서비스에 한해 지원되고 있습니다."
      },
      {
        title: "유료 서비스인가요?",
        description:
          "블록체인 네트워크에 지불하는 수수료를 제외하고 서비스는 모두 무료입니다."
      },
      // {
      //   title: "샌드뱅크는 안전한가요?",
      //   description:
      //     "샌드뱅크는 VASP 기업인 헥슬란트의 지갑 솔루션을 사용하여 예치된 자산을 해킹이나 사기로부터 안전하게 보관하고 있습니다. 또한 자동화 기반의 리스크 관리 시스템을 통해 고객 자금 보안을 최우선으로 두고 운용하고 있습니다. 높은 수준의 보안 및 리스크 관리를 통해 샌드뱅크는 2022년 테라/루나 사태와 FTX 사태때 인출 불가 및 운용 손실 피해를 입은 이력이 없습니다."
      // },
      {
        title: "만약 궁금한 점이나 문제가 생겼을때는 어떻게 연락할 수 있나요?",
        description:
          "샌드뱅크는 다양한 채널을 통해 고객과 소통하고 있습니다. 고객센터를 통해 문의하시면 최대한 신속하게 답변 드리겠습니다. <br/><br/><b>모바일 앱 이용시</b><br/>샌드뱅크 앱 내의 [마이 페이지]에서 [고객센터] 메뉴를 선택하시면 채널톡 창이 열리며, [새 문의하기] 선택 → [1:1 상담 문의하기]를 선택하시면 상담사와 연결됩니다.<br/><br/><b>홈페이지 이용시</b><br/>화면 우측 하단 보라색 아이콘을 클릭하시면 채널톡 창이 열립니다. [새 문의하기] 버튼 클릭 → [1:1 상담 문의하기]를 클릭하시면 상담사와 연결됩니다. "
      }
    ]
  },

  appDownload: {
    title: "편리한 디지털 자산 관리<br/>지금 바로 경험해보세요",
    items: [
      {
        name: "GOOGLE PLAY",
        url: "https://sandbankapp.onelink.me/u9ZD/fb15e190",
        image: "/img/pages/main/google.png"
      },
      {
        name: "APP STORE",
        url: "https://sandbankapp.onelink.me/u9ZD/fb15e190",
        image: "/img/pages/main/apple.png"
      }
    ]
  },

  page: {
    intro: {
      phone_image: "/img/pages/main/intro_phone.png"
    },
    strength: {
      phone_image: "/img/pages/main/strength_phone.png"
    }
  },
  about_intro: {
    title: "블록체인 / WEB 3.0 기술 기업 <br /> 디에이그라운드",
    img: "img/pages/main/company_logo.png",
    description:
      "디에이그라운드는 블록체인과 핀테크 기술 역량을 기반으로 WEB 3.0 생태계를 개척하는 B2C / B2B 테크핀 기업입니다."
  },
  about_business: {
    title: "사업 영역",
    items: [
      {
        title: "샌드뱅크",
        description: "크립토 종합 자산관리 서비스",
        img: "/img/pages/main/Value_1.jpg"
      },
      // {
      //   title: "SmashFi",
      //   description: "글로벌 거래소 파트너십 기반의 Web3.0 투자 서비스",
      //   img: "/img/pages/main/Value_2.jpg"
      // },
      {
        title: "B2B 솔루션 사업",
        description:
          "STO / NFT 관련 SI 개발 및 자체 구축 솔루션 제공 (금융사 및 글로벌 블록체인 프로젝트)<br/>B2B 대상 온/오프체인/유관 데이터 및 자체 인덱스 제공<br/><br/>문의: <a href='mailto:info@daground.io'><b>info@daground.io</b></a>",
        img: "/img/pages/main/Value_3.jpg"
      },
      {
        title: "블록체인 컨설팅 및 교육 사업",
        description:
          "비즈니스 요구에 맞는 프로토콜 설계 컨설팅<br/>기업 및 기관 대상 블록체인 특화 교육 프로그램 제공<br/><br/>문의: <a href='mailto:info@daground.io'><b>info@daground.io</b></a>",
        img: "/img/pages/main/Value_4.jpg"
      }
    ]
  },
  about_value: {
    title: "핵심가치",
    items: [
      {
        img: "/img/pages/main/신뢰.png",
        title: "신뢰",
        description:
          "서비스가 지켜야 할 가장 중요한 가치는 고객의 신뢰를 잃지 않는 것입니다. 항상 투명성과 정직함을 기반으로 한 서비스를 만듭니다."
      },
      {
        img: "/img/pages/main/혁신.png",
        title: "혁신",
        description:
          "신뢰를 기반으로 언제나 다음 단계를 향해 도전하고 혁신할 것입니다. 고객들에게 최고의 가치를 가져다줄 수 있는 서비스를 만듭니다."
      },
      {
        img: "/img/pages/main/전문성.png",
        title: "전문성",
        description:
          "디에이그라운드 팀은 금융 산업의 전문가들과 크립토 산업의 초기 개척자들입니다. 전문성을 기반으로, 우월하고 경쟁력 있는 서비스를 제공할 것입니다."
      }
    ]
  },
  about_founder: {
    title: "Co-Founder",
    quote: "/img/pages/main/quote.png",
    items: [
      {
        img: "/img/pages/main/homepage-CEO.jpg",
        title: "CEO",
        co_founder: "공동창업자",
        name: "이현명",
        description:
          "“디에이그라운드의 대표이사이자 프론트엔드 개발자입니다. 국내 최고의 투자은행인 미래에셋증권에서 파생상품 및 트레이딩 시스템을 기획하고 설계를 담당했으며 암호화폐 거래소 코인원의 초기 멤버로 합류하며 기존 금융산업과 디지털 자산 금융의 성장을 두루 경험했습니다.”",
        list: [
          "KAIST 전산학부 학사",
          "前 가상자산거래소 CGEX 최고전략책임자(CSO)",
          "前 가상자산거래소 코인원 전략/사업개발 팀장",
          "前 가상자산거래소 코인원 기획/PM 팀장",
          "前 미래에셋증권(구 대우증권) MTS 기획 PM",
          "前 미래에셋증권(구 대우증권) 파생상품 업무설계 PM"
        ]
      },
      {
        img: "/img/pages/main/homepage-COO.jpg",
        title: "COO",
        co_founder: "공동창업자",
        name: "백훈종",
        description:
          "“디에이그라운드의 COO로 사업개발과 영업, 마케팅을 책임지고 있습니다. 국내 최대의 OEM 벤더 세아상역에서 미주 바이어 해외영업을 담당했고 코인원 거래소에서는 법인고객 영업 매니저로 일하는 하는 등 다양한 산업과 국가를 대상으로 영업 경험을 쌓았습니다.”",
        list: [
          "George Washington Univ, Business Admin",
          "前 가상자산거래소 코인원 법인영업 매니저",
          "前 가상자산거래소 코인원 사업개발 매니저",
          "前 세아상역 해외영업 소싱"
        ]
      },
      {
        img: "/img/pages/main/homepage-CIO.jpg",
        title: "CIO",
        co_founder: "공동창업자",
        name: "김정운",
        description:
          "“디에이그라운드의 자산운용 총괄입니다. 코인원에서 사업개발 업무를 했으며 글로벌 디지털 자산 거래소 CGEX 설립 전략을 담당했습니다. 이후 AI Network에서는 토큰 생태계 설계하고 성장 전략을 수립했습니다.”",
        list: [
          "서울대학교 경영학부 학사",
          "前 가상자산거래소 CGEX 사업개발 매니저",
          "前 가상자산거래소 코인원 사업개발 매니저"
        ]
      },
      {
        img: "/img/pages/main/homepage-CTO.jpg",
        title: "CTO",
        co_founder: "공동창업자",
        name: "박수진",
        description:
          "“디에이그라운드의 CTO이자 풀스택 엔지니어입니다. 국내 최대 투자은행인 미래에셋증권에서 자기자본 원장 및 트레이딩 시스템을 개발 및 운영했으며, 디렉셔널에서 P2P 주식 대차 플랫폼 개발팀을 이끌었습니다.”",
        list: [
          "국민대학교 컴퓨터공학부 학사",
          "前 핀테크 스타트업 디렉셔널 최고기술책임자(CTO)",
          "前 미래에셋증권(구 대우증권) IT부문 선임 매니저",
          "前 미래에셋증권(구 대우증권) 법인 Trading System 개발",
          "前 미래에셋증권(구 대우증권) 법인 원장 시스템 개발"
        ]
      }
    ]
  },

  about_partner: {
    title: "투자사 및 파트너",
    items: [
      {
        name: "PRIMER",
        image: "/img/pages/main/partner_primer_color.png",
        url: "https://primer.kr"
      },
      {
        name: "STRONG VENTURES",
        image: "/img/pages/main/partner_strong_color.png",
        url: "https://www.strongvc.com"
      },
      {
        name: "KICA",
        image: "/img/pages/main/partner_kica_color.png",
        url: "https://www.kica.co.kr/kica/main/formMain.sg"
      },
      {
        name: "GOOGLE FOR STARTUP",
        image: "/img/pages/main/partner_google_color.png",
        url: "https://www.campus.co/intl/ko_kr/seoul/"
      },
      {
        name: "CHAINLINK",
        image: "/img/pages/main/partner_chainlink_color.png",
        url: "https://chain.link"
      },
      {
        name: "HAECHI LABS",
        image: "/img/pages/main/partner_haechi_color.png",
        url: "https://haechi.io"
      },
      {
        name: "HEXLANT",
        image: "/img/pages/main/partner_hexlant_color.png",
        url: "https://hexlant.com"
      }
    ]
  },
  footer: {
    title: `(주)디에이그라운드`,
    mail: "info@daground.io",
    policy: [
      {
        name: "이용약관",
        text: "lorem",
        url: "https://sandbankofficial.notion.site/efcae7fc67b94d1aafc2c53168cf64e4"
      },
      {
        name: "개인정보처리방침",
        text: "lorem",
        url: "https://sandbankofficial.notion.site/21a0613b314946759fb652150972ae1b"
      },
      {
        name: "마케팅정보수신동의",
        text: "lorem",
        url: "https://sandbankofficial.notion.site/ae8be83e0a4f47f08a522892c1335388"
      }
    ],
    social: [
      {
        name: "FACEBOOK",
        image: "/img/pages/footer/facebook.png",
        url: "https://www.facebook.com/sandbank.official"
      },
      {
        name: "TWITTER",
        image: "/img/pages/footer/twitter.png",
        url: "https://twitter.com/sandbank_kr/"
      },
      {
        name: "YOUTUBE",
        image: "/img/pages/footer/youtube.png",
        url: "https://www.youtube.com/channel/UC2tM460k4I6vSxktyDDkSsA"
      },
      {
        name: "BLOG",
        image: "/img/pages/footer/naverblog.png",
        url: "https://blog.naver.com/sandbank_official"
      },
      {
        name: "MEDIUM",
        image: "/img/pages/footer/medium.png",
        url: "https://medium.com/sandbank-kr"
      }
    ],
    info: "(주)디에이그라운드 | 대표 이현명 | 사업자등록번호 190-88-01294",
    address: "서울특별시 강남구 학동로30길 34 하림빌딩 2층",
    copyright: "© Copyright 2019-2026 DAGROUND Inc. All Rights Reserved."
  },

  modal: {
    desktopImage: "/img/pages/modal/modal_sams_web.png",
    mobileImage: "/img/pages/modal/modal_sams_app.png",
    url: "https://medium.com/sandbank-kr/%EC%9E%90%EC%82%B0%EA%B4%80%EB%A6%AC-%EA%B8%B0%EB%8A%A5-%EC%8C%A4%EC%A6%88-sams-%EC%B6%9C%EC%8B%9C-%EC%95%88%EB%82%B4-cc02cd3f8481"
  },
  appInfo: [
    {
      id: 1,
      image: "/img/pages/main/main_info_1.png",
      title: "쉬워지는 크립토 자산관리",
      text: "어디에, 얼마나 갖고 있는지도 모르는 코인들 😰 <br /> 모두 샌드뱅크에 연동해서 한 번에 관리하세요"
    },
    {
      id: 2,
      image: "/img/pages/main/main_info_2.png",
      title: "캘린더로 정리하는 투자 내역",
      text: "내역을 수집해 캘린더로 깔끔하게 보여드려요 📅 <br /> 이제 손쉽게 과거 내역을 확인할 수 있습니다"
    },
    {
      id: 3,
      image: "/img/pages/main/main_info_3.png",
      title: "안전하게 경험하는 크립토 투자",
      text: "지갑 속에 잠자고 있는 내 코인들 😴 <br /> 샌드뱅크와 함께 매일 보상을 받아가세요"
    },
    {
      id: 4,
      image: "/img/pages/main/main_info_4.png",
      title: "놓칠 수 있는 소식 하나까지도",
      text: "매일 쏟아지는 크립토 시장 뉴스를 빠르게 확인하고 <br /> 실시간으로 알림을 받아보세요"
    },
    {
      id: 5,
      image: "/img/pages/main/main_info_5.png",
      title: "차곡차곡 쌓여가는 크립토 지식",
      text: "크립토 시장 동향, 리포트, 컬럼, 규제 등 <br /> 유용한 콘텐츠를 주제별로 골라 볼 수 있어요"
    }
  ]
};
